import { ActionType } from 'typesafe-actions';
import * as actions from 'store/actions/calendar';
import { call, put, takeEvery } from 'redux-saga/effects';
import { rejectPromiseAction, resolvePromiseAction } from 'redux-saga-promise-actions';
import Endpoints from 'endpoints';
import { CalendarFailure, CalendarResponse } from 'store/types';
import GipsyApiGds from 'apis/GipsyGDS';

function* getCalendar(action: ActionType<typeof actions.getCalendar.request>) {
  const { idDepartureLocation, idArrivalLocation, departureDate, passengerType } = action.payload;
  const urlParams = new URLSearchParams(window.location.search);
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: CalendarResponse } = yield GipsyApiGds.get(Endpoints.getCalendar, {
      params: {
        idDepartureLocation,
        idArrivalLocation,
        departureDate,
        passengerType: passengerType || urlParams.get('passenger_type'),
      },
      headers: {
        Authorization: `bearer ${token}`,
      },
    });
    yield call(resolvePromiseAction, action, response.data.data);
    yield put(actions.getCalendar.success(response.data.data));
  } catch (error) {
    const { value } = error as CalendarFailure;
    yield put(actions.getCalendar.failure({ value }));
    yield call(rejectPromiseAction, action, error);
  }
}

export const watchCalendar = [takeEvery(actions.getCalendar.request, getCalendar)];
